import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=4acffa96&scoped=true"
import script from "./Base.vue?vue&type=script&lang=ts"
export * from "./Base.vue?vue&type=script&lang=ts"
import style0 from "./Base.vue?vue&type=style&index=0&id=4acffa96&prod&scoped=true&lang=css"
import style1 from "./Base.vue?vue&type=style&index=1&id=4acffa96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acffa96",
  null
  
)

export default component.exports